import eventBus from './global-event-bus'

let s = 1
const m = {}
function getSessionId() {
  return s++
}

export function jsBridge(cmdid, sessionid, params) {
  const data = {
    cmdid,
    sessionid,
    params
  }
  console.log('发送数据', data)
  window.messageHandlers && window.messageHandlers.setAction(JSON.stringify(data))
  window.webkit && window.webkit.messageHandlers.setAction.postMessage(JSON.stringify(data))
}

function WebViewJavascriptBridgeReturn(responseData) {
  try {
    console.log('接受数据', responseData)
    const obj = JSON.parse(responseData)
    console.log('sessionid', obj?.sessionid)
    console.log('sessionidCB', m?.[obj?.sessionid]?.toString())

    const { sessionid, err_code } = obj
    if (err_code === 404) {
      return
    }
    if (sessionid > 0) {
      if (m[sessionid]) {
        console.log('执行m[sessionid]回调')
        m[sessionid](obj)
        delete m[sessionid]
      }
    } else {
      const { cmdid, params } = obj
      eventBus.$emit(cmdid, params)
    }
  } catch (e) {
    console.log(e)
  }
}

window.WebViewJavascriptBridgeReturn = WebViewJavascriptBridgeReturn

export function appCall(cmdid, params, callback) {
  const sessionid = getSessionId().toString()
  console.log('app call:')
  console.log(cmdid)
  console.log(params)
  m[sessionid] = callback
  jsBridge(cmdid, sessionid, params)
}

export function appCallByPromise(cmdid, params = {}) {
  return new Promise((resolve) => {
    appCall(cmdid, params, resolve)
  })
}

/**
 * @desc 关闭webview
 *
 * */
export function onClose() {
  return appCallByPromise('close')
}

/**
 * @desc 跳转登录页
 *
 * */
export function userLogin(params) {
  return appCallByPromise('user-login', params)
}

/**
 * @desc 设置页面标题
 * @param {string} title - 页面标题
 *
 * */
export function setTitle(title) {
  return appCallByPromise('set-title', {
    title
  })
}

/**
 * @desc 复制到粘贴板
 * @param {string} content - 复制内容
 * @param {boolean} is_open_dy - 是否打开抖音
 *
 * */
export function copy2Clipboard(content = '', is_open_dy = false, match_id = '') {
  console.log('content', content)
  return appCallByPromise('set-copy-content', { content, is_open_dy, match_id })
}

/**
 * @desc 打开抖音
 * @param  {number} type - 1是视频，2是直播，3是个人页, 4是抖音商城某个商品
 * @param {number} content - id
 *
 * */
export function openDouYin(content = '', type = 1) {
  return appCallByPromise('open_dy_direct', { content, type })
}

/**
 * @desc 跳转小程序url
 * @param  {string} url - 视频id
 *
 * */
export function openRouteLink(url = '') {
  return appCallByPromise('route-link', { url })
}

// 打开新页面 open-web-page
export function openWebPage(url) {
  return appCallByPromise('open-web-page', {
    url
  })
}

export function getToken() {
  return appCallByPromise('get-user-token')
}

// 获取APP的版本号
export function getAppVersion() {
  return appCallByPromise('get-app-version')
}
// 打开抖音
export function mustDoOnce() {
  return appCallByPromise('must-do-once')
}
// 消息读完刷新
export function readMessageDone() {
  return appCallByPromise('refresh-message')
}
// 上报app事件
export function reportAppEvent(category, action, opt_label, data = {}) {
  return appCallByPromise('report-app-event', {
    category,
    action,
    opt_label,
    data
  })
}
// 消息读完刷新
export function closeMustDo() {
  return appCallByPromise('close-must-do')
}
